import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { clearCustomer, clearCustomerDataOld, i18n, mediaQuery, setExamDraft, setFlowType, setProgressBarPercentage, setSoId, setSoIdWeb, useAppDispatch } from 'src/common';
import { Card, Flex, Text, ThankYouIcon } from 'src/components';
import config from 'src/config';
import { colors, footer, header } from 'src/theme';

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    maxWidth: 485,
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const TextStyle = styled(Text)({
  lineHeight: "20px",
  textAlign: 'center',
  whiteSpace: 'pre-line',
});

const TextLinkStyle = styled.a({
  display: 'inline-block',
  cursor: 'pointer',
  fontSize: 16,
  fontWeight: 700,
  textDecoration: 'none',
  maginBottom: 32,
  color: colors.black,

  '&:hover': {
    color: colors.primary,
  },
});

const TitleTextStyle = styled.div({
  textAlign: 'center',

  [mediaQuery('laptopL')]: {
    paddingLeft: 78,
    paddingRight: 78,
  },
});

const ThankYouPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSoIdWeb(null));
    dispatch(setSoId(null));
    dispatch(clearCustomer());
    dispatch(setExamDraft(null));
    dispatch(setFlowType('web'));
    dispatch(setProgressBarPercentage(0));
    dispatch(clearCustomerDataOld());
  }, []);

  return (
    <FlexStyle justify="center" align="center">
      <Card >
        <Flex vertical gap={24} align="center">
          <Flex vertical align="center" gap={8}>
            <ThankYouIcon color={colors.primary} width={48} height={48} style={{ marginBottom: 16 }} />
            <TitleTextStyle>
              <Text type="large" bold>
                {i18n.t('pages.thankYouAdditional.title')}
              </Text>
            </TitleTextStyle>
            <TextStyle type="base" color={colors.text2}>
              {i18n.t('pages.thankYouAdditional.subtitle')}
            </TextStyle>
          </Flex>
          <TitleTextStyle>
            <TextLinkStyle href={config.REACT_APP_KOMPARE_HOME || 'https://kompare.hr/'} target="_self" rel="noopener noreferrer">
              {i18n.t('pages.thankYouAdditional.ctaButton')}
            </TextLinkStyle>
          </TitleTextStyle>
        </Flex>
      </Card>
    </FlexStyle>
  );
};

export default ThankYouPage;